import { AppRouteProps } from "@bsm/component";
import { StudentParentsContainer } from "./container/StudentParentsContainer";

export const StudentParentsRoutes: Array<AppRouteProps> = [
    {
        path: "parents",
        element: <StudentParentsContainer />,
    },
];